import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { getUser as getUserAction } from 'ggApp/modules/auth/actions';
import { saveAccessToken } from 'ggApp/modules/auth/utils';
import { user as userSelector } from 'ggApp/modules/auth/selectors';
import { inlineAccessToken as inlineAccessTokenSelector } from 'ggApp/modules/router/selectors';
import CircleLoader from 'ggApp/shared/components/CircleLoader';

@connect(
    createStructuredSelector({
        user: userSelector,
        inlineAccessToken: inlineAccessTokenSelector,
    }),
    (dispatch) => ({
        getUser: bindActionCreators(getUserAction, dispatch),
    }),
)
export class PrefetchUser extends Component {
    componentDidMount() {
        const { inlineAccessToken, getUser } = this.props;
        if (inlineAccessToken) {
            saveAccessToken(inlineAccessToken);
        }
        getUser();
    }

    render() {
        const { user, children } = this.props;
        if (!user) return <CircleLoader />;
        return children;
    }
}
